// src/hooks/useCensusData.js
import { useState, useEffect } from "react";
import api from "../Api";

export default function useCensusData(activity) {
  const [censusData, setCensusData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCensus = async () => {
      if (
        activity &&
        activity.activity_names?.some(
          (name) => name.toLowerCase() === "censimento_arboreo"
        )
      ) {
        setLoading(true);
        try {
          const res = await api.get(`/census/${activity.id}`);
          if (res.data && res.data.length > 0) {
            setCensusData(res.data[0]);
          }
        } catch (err) {
          console.error("Errore nel recupero dei dati del censimento:", err);
          setError(err);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchCensus();
  }, [activity]);

  return { censusData, loading, error };
}
